const config = {
  apiBaseUrl: 'https://crm-server.everviz.com'
};

export default config;
